module.exports = __webpack_public_path__ + "img/search-background.565469ad.png";